import * as v from "valibot";
import { ContentType } from "@/shared/gql/graphql";

export const searchParams = v.object({
  createWorkflow: v.optional(v.boolean()),
  contentType: v.optional(v.enum(ContentType)),
});
